import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import initApp from 'utils/functions/init';
import { contexts } from 'constants/context';
import { status } from 'constants/general';
import { fetchProfileDetails } from 'modules/profiles/actions';
import UpdateProfileView from 'modules/profiles/views/UpdateProfileView';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const UpdateProfilePage = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { companyProfilesList } = useSelector(state => ({
    companyProfilesList: state.common.companyProfilesList,
  }));

  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  const profileDetailsApiCall = () => {
    const body = {
      profileKey: sessionStorage.getItem('companyProfileKeyAuthCookie'),
    };
    dispatch(fetchProfileDetails(body));
  };

  useEffect(() => {
    initApp(contexts.profile);
  }, []);

  useEffect(() => {
    if (companyProfilesList.status === status.SUCCESS) {
      profileDetailsApiCall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyProfilesList]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return <UpdateProfileView profileDetailsApiCall={profileDetailsApiCall} />;
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

UpdateProfilePage.propTypes = {};

UpdateProfilePage.defaultProps = {};

export default UpdateProfilePage;
